import React, {Component} from "react";
import {injectIntl} from "react-intl";
import DriveIn from "./DriveIn";
import Fastlane from "./Fastlane";
import Desk from "./Desk";
import LoadingIndicator from "../../common/loading/LoadingIndicator";
import OutsideBusinessHour from "./OutsideBusinessHour";
import Constants from "../../../services/Constants";
import {connect} from "react-redux";
import Intervention from "../../../services/Intervention";
import './ReceptionCard.css';
import {Col, Row} from "antd";
import Card from "../../common/Card";
import Alert from "../../common/Alert";

class ReceptionCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pristine: false
    };
  }

  componentDidMount() {
    const {intervention: {journey}} = this.props;
    if (journey.id) {
      this.props.dispatchFetchJourneySignature({id: journey.id, signatureType: Constants.SIGNATURE_REQUESTED_SERVICES.value});
      this.props.dispatchFetchJourneySignature({id: journey.id, signatureType: Constants.SIGNATURE_PERFORMED_SERVICES.value});
    }
    if (journey.properties) {
      const {reception: {dropOff = {}} = {}} = journey.properties;
      this.setState({dropOff : {...dropOff}});    // must be copied, so old values can be used to detect errors
    }
  }

  onReceptionSave = () => {
    const {intervention: {journey: {id}}} = this.props;
    const {dropOff} = this.state;
    this.props.dispatchUpdateJourneyReception({id, body: {dropOff}});
  };

  on247Select = () => {
    const {dropOff} = this.state;
    Object.assign(dropOff, {driveIn: false, fastLane: false, duringWorkingHours: false});
    this.setState({dropOff, pristine: true});
  };

  onFastlaneSelect = () => {
    const {dropOff} = this.state;
    Object.assign(dropOff, {driveIn: false, fastLane: true, duringWorkingHours: true});
    this.setState({dropOff, pristine: true});
  };

  onDriveInSelect = () => {
    const {dropOff} = this.state;
    Object.assign(dropOff, {driveIn: true, fastLane: false, duringWorkingHours: true});
    this.setState({dropOff, pristine: true});
  };

  onDeskSelect = () => {
    const {dropOff} = this.state;
    Object.assign(dropOff, {driveIn: false, fastLane: false, duringWorkingHours: true});
    this.setState({dropOff, pristine: true});
  };

  render() {
    const {intl: {formatMessage}, intervention, intervention: {journey}, mainServices: {receptionOffering, offering}, canWrite} = this.props;
    const {updateJourneyReception: {error = {}}} = this.props;
    const {properties: {reception = {}} = {}} = journey;
    const {dropOff, pristine} = this.state;

    if (!Intervention.isTypeAppointment(intervention) || !journey || !reception) {
      return null;
    }
    if (!receptionOffering || !offering){
      return <LoadingIndicator/>
    }

    const errors = error.content || {};
    const defaultReception = reception.dropOff && reception.dropOff.duringWorkingHours === false;
    const currentReception = dropOff && dropOff.duringWorkingHours === false;
    if (defaultReception ^ currentReception) {
      errors.reception = {message: 'error.reception.247-uncheck'};
    }

    const selectDropOffFastLane = dropOff && dropOff.fastLane === true;
    const selectDropOff24_7 = dropOff && dropOff.duringWorkingHours === false;
    const selectDropOffDriveIn = dropOff && dropOff.driveIn === true;
    const selectDropOffDesk = !selectDropOffFastLane && !selectDropOff24_7 && !selectDropOffDriveIn;

    const selectPickup24_7 = reception && reception.pickUp && reception.pickUp.duringWorkingHoursChoice === false;

    const dropOffSignature = intervention[Constants.SIGNATURE_REQUESTED_SERVICES.value];
    const pickupSignature = intervention[Constants.SIGNATURE_PERFORMED_SERVICES.value];
    const canUpdateReception = canWrite && !Intervention.isComplete(intervention);

    const customerOffering = (intervention.vehicle.brand === 'BMW') ? 'bmwOffering' : 'miniOffering';
    return (

     <Card
       title={formatMessage({id: 'appointment.detail.reception.title'})}
       pristine={pristine}
       onAlert={journey.requiresAttention.includes('reception')}
       button={canUpdateReception &&
         <button type="primary" onClick={this.onReceptionSave} disabled={!pristine} className={`btn btn-sm btn-primary`}>
           {formatMessage({id: 'action.save'})}
         </button>
       }
      >
          <h3 className="box__subtitle">{formatMessage({id:'appointment.detail.reception.dropoff.title'})}</h3>
          {errors && errors.reception &&
          <div className="alert alert--error">
            {formatMessage({id: errors.reception.message})}
          </div>
          }
          {intervention.journey.towing &&
            <Alert type="info" className="branded-border-color branded-color" message={formatMessage({id: 'appointment.detail.reception.towing.title'})}/>
          }

          <Row gutter={16}>
            {!Intervention.isWeb(intervention) && offering && offering.carDropOff === true &&
            <Col span={6}>
              <OutsideBusinessHour selected={selectDropOff24_7} type={Constants.DROPOFF_247} intervention={intervention}
                                   signature={dropOffSignature} canWrite={canWrite} selectable={canUpdateReception}
                                   onSelect={this.on247Select}/>
            </Col>
            }
            {!Intervention.isWeb(intervention) && receptionOffering && receptionOffering[customerOffering].fastlaneDesk === true &&
            <Col span={6}>
              <Fastlane selected={selectDropOffFastLane} journey={journey} signature={dropOffSignature} selectable={canUpdateReception}
                        onSelect={this.onFastlaneSelect}/>
            </Col>
            }
            {receptionOffering && receptionOffering[customerOffering].driveIn !== Constants.DRIVE_IN_NONE &&
            <Col span={6}>
              <DriveIn selected={selectDropOffDriveIn} selectable={canUpdateReception} onSelect={this.onDriveInSelect}/>
            </Col>
            }
            {receptionOffering && receptionOffering[customerOffering].driveIn !== Constants.DRIVE_IN_MANDATORY &&
            <Col span={6}>
              <Desk selected={selectDropOffDesk} selectable={canUpdateReception} onSelect={this.onDeskSelect}/>
            </Col>
            }
          </Row>

          <h3 className="box__subtitle">{formatMessage({id:'appointment.detail.reception.pickup.title'})}</h3>
          <Row gutter={16}>
            {!Intervention.isWeb(intervention) && offering && offering.carPickup === true &&
            <Col span={12}>
              <OutsideBusinessHour selected={selectPickup24_7} type={Constants.PICKUP_247} intervention={intervention}
                                   signature={pickupSignature} canWrite={canWrite}/>
            </Col>
            }
            <Col span={12}>
              <Desk selected={!selectPickup24_7}/>
            </Col>
          </Row>
        </Card>

    )
  }
}

const mapStateToProps = state => ({
  intervention: state.fetchIntervention.intervention || {},
  updateJourneyReception: state.updateJourneyReception
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchJourneySignature: (params) => dispatch({type: 'FETCH.JOURNEY_SIGNATURE.REQUEST', ...params}),
  dispatchUpdateJourneyReception: (params) => dispatch({type: 'UPDATE_JOURNEY_RECEPTION.REQUEST', ...params})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ReceptionCard))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/reception/ReceptionCard.js